import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";

import { useTranslation } from 'react-i18next';

import { useCanviIdioma } from './IdiomasMovil.jsx';
import { RUTA_IMATGES, MENU, rutaPagina } from './contenidoCamprodon.js';

import CookieConsentPopup from './CookieConsentPopup.jsx';

import "../../../../../css/web/bedloop1/styles.css";
import "../../../../../css/web/motorhotel/styles.css";
import "../../../../../css/web/hotelcamprodon/global.css";
import "../../../../../css/web/hotelcamprodon/camprodon.css";
import iniciarAnimarCambios from "./animarCambios";

const stripHtml = (html) => {
    return html.replace(/<[^>]*>/g, '');
};

const Menu = ({ destinos, sobrenosotros, clientes, propietarios, servicios, experiencias, idiomas, lang, tiposcasas, config, textopropiedades, edificios, marcas, ruta, destinoslarga, meta_titulo, meta_descripcion, meta_keywords, numblog, numfaqs, paginapersonalizada, transparente }) => {
    const { t } = useTranslation();

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    useEffect(() => {
        if (config.css_personalizado) {
            const linkElement = document.createElement('link');
            linkElement.rel = 'stylesheet';
            linkElement.type = 'text/css';
            linkElement.href = config.css_personalizado;
            const headElement = document.head;
            headElement.appendChild(linkElement);
        }

    }, []);

    // --corporatiu ja existeix a app.css (.btn-primary hi referencia el
    // color de marca) però mai s'assignava enlloc — es fixa aquí, a
    // <html>, perquè arribi a totes les pàgines (Menu.jsx es carrega
    // sempre) independentment de si l'element que el necessita és
    // germà o no de <Menu>. Permet fer :hover en CSS pur amb el color
    // corporatiu real del tenant, cosa que un style inline no pot fer.
    useEffect(() => {
        if (config.color_corporativo_web) {
            document.documentElement.style.setProperty('--corporatiu', config.color_corporativo_web);
        }
    }, [config.color_corporativo_web]);

    // Animació dels canvis d'informació (entra / surt / canvia de valor)
    useEffect(() => iniciarAnimarCambios(), []);

    // Portada: capçalera transparent damunt la foto del hero, que passa a
    // blanca en baixar (c-header--stuck del disseny). A la resta de pàgines,
    // sempre blanca.
    const [enganxada, setEnganxada] = useState(!transparente);
    const [menuObert, setMenuObert] = useState(false);
    const [submenuObert, setSubmenuObert] = useState(null);

    useEffect(() => {
        if (!transparente) return;
        const alFerScroll = () => setEnganxada(window.scrollY > 40);
        alFerScroll();
        window.addEventListener('scroll', alFerScroll, { passive: true });
        return () => window.removeEventListener('scroll', alFerScroll);
    }, [transparente]);

    useEffect(() => {
        if (!menuObert) return;
        const alTeclear = (e) => { if (e.key === "Escape") setMenuObert(false); };
        window.addEventListener("keydown", alTeclear);
        return () => window.removeEventListener("keydown", alTeclear);
    }, [menuObert]);

    const { canviant, canviar } = useCanviIdioma(lang);
    const { i18n } = useTranslation();
    const idiomaActual = (lang || "es").toString().toLowerCase();

    useEffect(() => {
        i18n.changeLanguage(idiomaActual);
    }, [idiomaActual]);

    // Títol i descripció propis de cada pàgina, calculats al servidor
    // (App\Support\SeoWeb, window.__SEO__ a web/app.blade.php). Si no hi
    // són, els genèrics de la web com abans.
    const seoServidor = typeof window !== "undefined" ? window.__SEO__ : null;
    const tituloPagina = seoServidor?.title || meta_titulo;
    const descripcionLimpia = seoServidor?.description || (meta_descripcion ? stripHtml(meta_descripcion) : "");
    const keywordsLimpias = meta_keywords ? stripHtml(meta_keywords) : "";


    const handleCookieAccept = () => {
        console.log('Cookies aceptadas');
        // Inicializar Google Analytics, etc.
    };

    const handleCookieReject = () => {
        console.log('Cookies rechazadas');
        // No cargar scripts de tracking
    };

    const handleCookieConfigure = () => {
        console.log('Abrir configuración detallada');
        // Lógica para modal avanzado
    };

    const urlReserva = "/" + preidioma + t("buscar2");
    // "Reserva" del menú = cercador (buscar2).
    const enllac = (href) => href === "@reserva" ? urlReserva : href;

    // Menú del disseny + les seccions de BedLoop que tingui actives el client
    // (blog, experiències, edificis...), al final. "Empresa" no es mostra.
    const extres = [];
    if (edificios.length > 0) {
        extres.push(edificios.length === 1
            ? { href: "/" + preidioma + t("edificio") + "/" + edificios[0].url_dinamica, label: edificios[0].nombre, sub: [] }
            : { href: "/" + preidioma + t("edificio") + "/" + edificios[0].url_dinamica, label: t("Edificios"), sub: edificios.map((e) => ({ href: "/" + preidioma + t("edificio") + "/" + e.url_dinamica, label: e.nombre })) });
    }
    if (destinoslarga.length > 0) {
        extres.push({
            href: "/" + preidioma + t("alquilertemporada") + "-" + destinoslarga[0].laurl,
            label: t("Alquiler temporada"),
            sub: destinoslarga.length > 1 ? destinoslarga.map((d) => ({ href: "/" + preidioma + t("alquilertemporada") + "-" + d.laurl, label: d.elnombre })) : [],
        });
    }
    if (marcas.length > 0) {
        extres.push({
            href: "/" + preidioma + t("marca") + "/" + marcas[0].nombre,
            label: marcas.length > 1 ? t("Marcas") : marcas[0].nombre,
            sub: marcas.length > 1 ? marcas.map((m) => ({ href: "/" + preidioma + t("marca") + "/" + m.nombre, label: m.nombre })) : [],
        });
    }
    if (experiencias.length > 0) {
        extres.push({
            href: "/" + preidioma + t("experiencias") + "/" + experiencias[0].url_dinamica[lang],
            label: t("Experiencias"),
            sub: experiencias.map((e) => ({ href: "/" + preidioma + t("experiencias") + "/" + e.url_dinamica[lang], label: e.nombre[lang] })),
        });
    }
    if (numblog > 0) {
        extres.push({ href: "/" + preidioma + t("blog"), label: t("Blog"), sub: [] });
    }
    if (paginapersonalizada && paginapersonalizada.en_menu_empresa === 0 && paginapersonalizada.eltitulo) {
        extres.push({
            href: paginapersonalizada.amigable_o_externa === 1 ? "/" + preidioma + "web-" + paginapersonalizada.laurldinamica : paginapersonalizada.laurlexterna,
            label: paginapersonalizada.eltitulo,
            sub: [],
        });
    }

    // "Reserva" (el cercador) sempre l'últim, com al disseny.
    const deMenu = (item) => ({
        href: item.href || rutaPagina(item.pagina, idiomaActual),
        label: item.label || t(item.t),
        sub: (item.sub || []).map(deMenu),
    });
    const menuDisseny = MENU.filter((item) => item.href !== "@reserva").map(deMenu);
    const menuReserva = MENU.filter((item) => item.href === "@reserva").map(deMenu);
    const menu = [...menuDisseny, ...extres, ...menuReserva];

    const idiomesAltres = (idiomas || []).filter((idioma) => idioma.codigo !== idiomaActual);

    const cabecera = (
        <div className="hc">
            <div className={"header-notifier" + (!transparente ? " header-notifier--solid" : "")}></div>
            <header className={"c-header o-container" + (enganxada ? " c-header--stuck" : "") + (!transparente ? " c-header--solid" : "")} id="header">
                <a href={"/" + preidioma} aria-label={config.nombre_comercial || "Hotel Camprodon"} className="c-header__logo">
                    <svg aria-hidden="true" focusable="false" className="c-icon">
                        <use href={RUTA_IMATGES + "icons-sprite.svg#sprite-icon-logo-header"}></use>
                    </svg>
                </a>
                <div className="d-none-menu d-block-lg-menu">
                    <nav className="c-top-menu">
                        <ul className="c-menu c-menu--small list-style-none p-0">
                            <li className="c-menu__item">
                                <svg aria-hidden="true" focusable="false" className="c-icon" width="10" height="9">
                                    <use href={RUTA_IMATGES + "icons-sprite.svg#sprite-icon-ico-phone-menu"}></use>
                                </svg>
                                <a href={"tel:" + (config.telefono_fiscal || "").replace(/\s/g, "")} className="c-menu__link"> {config.telefono_fiscal}</a>
                            </li>
                            <li className="c-menu__item">
                                <a href={"/" + preidioma + t("contacto")} className="c-menu__link">{t("Contacto")}</a>
                            </li>
                        </ul>
                        {idiomas && idiomas.length > 1 && (
                            <div className="c-lang-selector">
                                <div className="c-lang-selector__current">
                                    {idiomaActual.toUpperCase()}
                                    <svg aria-hidden="true" focusable="false" className="c-icon dropdown-icon">
                                        <use href={RUTA_IMATGES + "icons-sprite.svg#sprite-icon-arrow-down-language"}></use>
                                    </svg>
                                </div>
                                <ul className="c-lang-selector__dropdown list-style-none">
                                    {idiomesAltres.map((idioma) => (
                                        <li className="c-lang-selector__item" key={idioma.codigo}>
                                            <button type="button" lang={idioma.codigo} title={idioma.nombre} disabled={canviant !== null && canviant !== idioma.codigo} onClick={() => canviar(idioma.codigo)}>
                                                {idioma.codigo.toUpperCase()}
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </nav>
                    <nav>
                        <ul className="c-menu c-menu--desktop list-style-none m-0 p-0">
                            {menu.map((item, index) => (
                                <li className="c-menu__item" key={index}>
                                    <a href={enllac(item.href)} className="c-menu__link">{item.label}</a>
                                    {item.sub.length > 0 && (
                                        <div className="c-menu__dropdown-container">
                                            <ul className="c-dropdown-menu list-style-none">
                                                {item.sub.map((sub, index2) => (
                                                    <li className="c-dropdown-menu__item" key={index2}>
                                                        <a href={enllac(sub.href)} className="c-dropdown-menu__link">{sub.label}</a>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                </li>
                            ))}
                        </ul>
                    </nav>
                </div>
                <div className="d-none-lg-menu">
                    <a href={"tel:" + (config.telefono_fiscal || "").replace(/\s/g, "")} aria-label={t("Teléfono")}>
                        <svg aria-hidden="true" focusable="false" className="c-icon" width="28" height="28">
                            <use href={RUTA_IMATGES + "icons-sprite.svg#sprite-icon-ico-phone-menu"}></use>
                        </svg>
                    </a>
                    <button type="button" className="hc-icon-button" aria-label="Menu" aria-expanded={menuObert} aria-controls="sidebar-menu" onClick={() => setMenuObert(!menuObert)}>
                        <svg aria-hidden="true" focusable="false" className="c-icon c-header__btn-open-menu" width="27" height="27">
                            <use href={RUTA_IMATGES + "icons-sprite.svg#" + (menuObert ? "sprite-icon-ico-close-menu" : "sprite-icon-ico-burger-menu")}></use>
                        </svg>
                    </button>
                </div>
            </header>

            {menuObert && <div className="hc-sidebar-backdrop" onClick={() => setMenuObert(false)}></div>}
            <nav className={"c-sidebar c-sidebar--menu" + (menuObert ? " c-sidebar--open" : "")} id="sidebar-menu" aria-hidden={!menuObert}>
                <ul className="c-menu c-menu--mobile list-style-none m-0 p-0">
                    {menu.map((item, index) => (
                        item.sub.length > 0 ?
                            <li className="c-menu__item dropdown" key={index}>
                                <div
                                    className={"c-menu__item--title" + (submenuObert === index ? " open" : "")}
                                    role="button"
                                    tabIndex={0}
                                    aria-expanded={submenuObert === index}
                                    onClick={() => setSubmenuObert(submenuObert === index ? null : index)}
                                    onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setSubmenuObert(submenuObert === index ? null : index); } }}
                                >
                                    {item.label}
                                    <div className={"dropdown-icon" + (submenuObert === index ? " up" : "")}></div>
                                </div>
                                <div className="c-menu__dropdown-container">
                                    <ul className={"c-menu c-menu--mobile list-style-none m-0 p-0" + (submenuObert === index ? " is-open" : "")}>
                                        <li className="c-menu__item pl-0">
                                            <a href={enllac(item.href)} className="c-menu__link">{item.label}</a>
                                        </li>
                                        {item.sub.map((sub, index2) => (
                                            <li className="c-menu__item pl-0" key={index2}>
                                                <a href={enllac(sub.href)} className="c-menu__link">{sub.label}</a>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </li>
                            :
                            <li className="c-menu__item" key={index}>
                                <a href={enllac(item.href)} className="c-menu__link">{item.label}</a>
                            </li>
                    ))}
                    <li className="c-menu__item">
                        <a href={"/" + preidioma + t("contacto")} className="c-menu__link">{t("Contacto")}</a>
                    </li>
                </ul>
                {idiomas && idiomas.length > 1 && (
                    <div className="hc-sidebar-lang" role="group" aria-label="Idioma">
                        {idiomas.map((idioma) => (
                            <button
                                type="button"
                                key={idioma.codigo}
                                lang={idioma.codigo}
                                title={idioma.nombre}
                                aria-pressed={idioma.codigo === idiomaActual}
                                disabled={canviant !== null && canviant !== idioma.codigo}
                                onClick={() => canviar(idioma.codigo)}
                            >
                                {idioma.codigo.toUpperCase()}
                            </button>
                        ))}
                    </div>
                )}
                <a href={urlReserva} className="c-button d-flex-center">{t("Reservar")}</a>
            </nav>
        </div>
    );

    return (
        <>
            <Helmet>
                <title>{`${tituloPagina}`}</title>
                <meta name="title" content={`${tituloPagina}`} />
                <meta name="description" content={descripcionLimpia} />
                <meta name="keywords" content={keywordsLimpias} />
                <meta charset="utf-8" />
            </Helmet>

            {
                (config.id === 1) ?
                    <Helmet>
                        <link rel="icon" type="image/x-icon" href={`${ruta}/web/favicon/favicon.ico`}></link>
                    </Helmet>
                    :
                    <Helmet>
                        <link rel="icon" type="image/x-icon" href={`${ruta}/web/favicon/${config.id}/favicon.ico`}></link>
                    </Helmet>
            }

            {/*
                (config.activa_analytics === 1) ?
                    <Helmet>
                        <script async src={`https://www.googletagmanager.com/gtag/js?id=${config.codigo_analytics}`}></script>
                        <script>
                            {`
                                window.dataLayer = window.data          }Layer || [];
                                function gtag(){window && window.dataLayer && window.dataLayer.push(arguments)}
                                gtag('js', new Date())
                                gtag('config', '${config.codigo_analytics}');
                            `}          }
                        </script>           }
                    </Helmet>           }
                    :
                    ""
            */}

            {
                (config.activa_analytics === 1) ?
                    <Helmet>
                        <script>
                            {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${config.codigo_analytics}');
                            `}
                        </script>
                    </Helmet>
                    :
                    ""
            }

            {
                (config.activa_analytics === 1) ?
                    <noscript>
                        {`<iframe src="https://www.googletagmanager.com/ns.html?id=${config.codigo_analytics}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`}
                    </noscript>
                    :
                    ""
            }

            <CookieConsentPopup
                onAccept={handleCookieAccept}
                onReject={handleCookieReject}
                onConfigure={handleCookieConfigure}
                policyUrl={preidioma + t("cookies")}
            />

            {cabecera}
        </>
    );
}

export default Menu;
